import Vue from 'vue';
import LoadScript from 'vue-plugin-load-script';
Vue.use(LoadScript);

if (process.env.VUE_APP_BEAMER_ID != '') {
  // GLOBAL variable for older style scripts like (beamers)
  let beamer_config = {
    product_id: process.env.VUE_APP_BEAMER_ID,
    selector: '.beamerSelector',
    delay: 2000,
  };

  // communicate using global window variables with th ebeamer api
  window.beamer_config = beamer_config;

  Vue.loadScript('https://app.getbeamer.com/js/beamer-embed.js')
    .then(() => {
      // what to do after beamer is loaded
    })
    .catch(() => {
      // Failed to fetch script
    });
}
